module.exports = __webpack_public_path__ + "img/goDataTemplate.a5811319.png";